<template>
  <v-container>
    <v-row text-xs-left wrap class="align-center">
      <v-col sm="2">
        <v-img
                :src="pics('./EndoPredict_Logo.png')"
                class="my-2"
                contain
                height="100">
        </v-img>
      </v-col>
      <v-col sm="3"></v-col>

      <v-col sm="3">
        <v-select
                v-model="language"
                :items="languages"
                item-text="name"
                item-value="id">
        </v-select>
      </v-col>

      <v-col sm="2"></v-col>
      <v-col sm="2">
        <v-img
                :src="pics('./Myriad_logo.png')"
                class="my-2"
                contain
                height="75"
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1 class="eprg-header mb-4">EndoPredict<sup>&reg;</sup> Report Generator</h1>
        <h2 class="eprg-subheader mb-4">{{ $t("subheader") }}</h2>

        <p class="eprg-text01" v-html="$t('mainText')"/>
        <p class="eprg-text01" v-html="$t('bookmarkText')"/>
      </v-col>

      <v-col cols="12" class="mb-5">
        <h2 class="headline font-weight-bold mb-3">{{ $t("regionsHeader") }}</h2>

        <span v-for="ra in ras" :key="ra.id" class="ra-button">
          <v-btn @click.native="requestEPRG(ra.name, ra.shortName, ra.endpoint, ra.url, ra.doRedirect)"
                 rounded color="#0071ce">
            <span class="white--text">{{ $t('regions.' + ra.name) }}</span>
          </v-btn>
        </span>

        <v-dialog v-model="dialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline" style="word-break: break-word">{{ $t('dialogHeader', {RA: $t("regions." + RA)}) }} </v-card-title>
            <v-container >
              <v-row justify="center" align="center" class="ml-0">
                <v-col sm="4">
                  <v-img :src="raFlag"></v-img>
                </v-col>
                <v-col sm="8">
                  <v-card-text> {{ $t("dialogText", {RA: $t("regions." + RA)}) }}</v-card-text>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click.native="dialog = false"> {{ $t("dialogExit")}} </v-btn>
              <v-btn color="green darken-1" text @click="goto(URL)">{{ $t("dialogContinue")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-col>
    </v-row>
    <div class="note text-xs-center mt-4 pa-2">
      <span v-html="$t('browserWarning')"></span>
    </div>

  </v-container>
</template>

<script>
    import {setLanguage, languages} from "../main";

    export default {
        name: 'ReportGeneratorRouterView',
        data: function () {
            return {
                RA: "Europe", // setting default to avoid console errors
                textMD: null,
                URL: null,
                endpoint: null,
                dialog: false,
                ras: window.$APP_CONFIG,
                language: "EN",
                languages: languages,
                raFlag: null,
                pics: null,
                doRedirect: false,
            };
        },
        created:
            function() {
                this.pics = require.context('../assets/', true, /\.png$/);
                this.raFlag = this.pics('./logo.png');
            },
        mounted:
            function() {
                setLanguage(this.language);
            },
        methods: {

            requestEPRG: function (RA, shortName, endpoint, URL, doRedirect) {
                this.RA = RA;
                this.URL = URL;
                this.endpoint = endpoint;
                this.dialog = true;
                this.doRedirect = doRedirect;
                this.raFlag = this.pics('./flags/' + shortName + ".png");
            },
            goto: function (url) {
                window.location.href=url;
            },
        },
        watch: {
            language: (lan) => {
            setLanguage(lan);
          },
        },
    };
</script>

<style>
  @import '../assets/styles/main.css';
</style>
